/* eslint-disable gatsby/use-gatsby-link */
/**
 * @see https://steverichey.github.io/google-play-badge-svg/
 * @see https://developer.apple.com/app-store/marketing/guidelines/
 */

import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import cn from 'clsx';
import * as css from './GetApp.module.scss';

import defaultApple from './svg/apple/EN.svg';
import defaultGoogle from './svg/google/EN.svg';

function loadImage(platform: Props['platform'], language: string): Promise<string> {
    return import(`./svg/${platform}/${language.toUpperCase()}.svg`).then(
        r => r.default,
        () => (platform === 'apple' ? defaultApple : defaultGoogle),
    );
}

type Props = {
    platform: 'apple' | 'google';
    href: string;

    width?: number | string;
    height?: number | string;

    lang?: string;
    title?: string;
};
export function GetApp({ platform, href, title, lang, width = 'auto', height = 48 }: Props) {
    const intl = useIntl();
    const locale = lang || intl.locale || 'en';

    const [image, setImage] = useState<string>(platform === 'apple' ? defaultApple : defaultGoogle);
    useEffect(() => {
        loadImage(platform, locale).then(setImage);
    }, [platform, locale]);

    return (
        <a href={href} target="_blank" rel="noreferrer noopener" title={title} className={cn(css.root, css[platform])}>
            <img src={image} alt={title || platform} style={{ width, height }} />
        </a>
    );
}
